import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'


export function SubirVehicle(form) {
   // console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}vehicle`, form, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al subir el equipo: " + err);
        });
    });
    }

    export function GetVehicle() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}vehicle`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al obtener los equipos: " + err);
            });
        });
    }

    export function EditarVehicle(form, id) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.post(`${url_local}edit_vehicle/${id}`, form, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al editar el equipo: " + err);
            });
        });
        }

    export function GetVehicle_select() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}vehicle_select`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al obtener el equipo: " + err);
            });
        });
    }

    export function DeleteVehicle(id) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.delete(`${url_local}vehicle/${id}`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al borrar el equipo: " + err);
            });
        });
    }

